import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import './ModalCrearUsuario.css';
import '../../pages/Induccion.css';

const HORAS_12 = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
const MINUTOS = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

function hora24a12(hhmm) {
  if (!hhmm || typeof hhmm !== 'string') {
    return { h: '9', m: '00', ap: 'AM' };
  }
  const t = hhmm.trim();
  const m = t.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return { h: '9', m: '00', ap: 'AM' };
  let H = parseInt(m[1], 10);
  const MM = m[2];
  const ap = H >= 12 ? 'PM' : 'AM';
  let h12 = H % 12;
  if (h12 === 0) h12 = 12;
  return { h: String(h12), m: MM, ap };
}

function hora12a24(h, minuto, ap) {
  let H = parseInt(h, 10);
  const MM = String(minuto).padStart(2, '0');
  if (ap === 'AM') {
    if (H === 12) H = 0;
  } else {
    if (H !== 12) H += 12;
  }
  return `${String(H).padStart(2, '0')}:${MM}`;
}

function ModalInduccionCrear({ isOpen, onClose, onSave, row }) {
  const [form, setForm] = useState({
    nombre_postulante: '',
    estado: '1',
    primera_induccion_fecha: '',
    segunda_induccion_fecha: '',
    primera_h_12: '9',
    primera_min: '00',
    primera_ap: 'AM',
    segunda_h_12: '9',
    segunda_min: '00',
    segunda_ap: 'AM',
  });

  useEffect(() => {
    if (!isOpen) return;
    if (row) {
      const p = hora24a12(row.primera_induccion_hora);
      const s = hora24a12(row.segunda_induccion_hora);
      setForm({
        nombre_postulante: row.nombre_postulante || '',
        estado: row.estado ? String(row.estado) : '1',
        primera_induccion_fecha: row.primera_induccion_fecha || '',
        segunda_induccion_fecha: row.segunda_induccion_fecha || '',
        primera_h_12: p.h,
        primera_min: p.m,
        primera_ap: p.ap,
        segunda_h_12: s.h,
        segunda_min: s.m,
        segunda_ap: s.ap,
      });
    } else {
      setForm({
        nombre_postulante: '',
        estado: '1',
        primera_induccion_fecha: '',
        segunda_induccion_fecha: '',
        primera_h_12: '9',
        primera_min: '00',
        primera_ap: 'AM',
        segunda_h_12: '9',
        segunda_min: '00',
        segunda_ap: 'AM',
      });
    }
  }, [isOpen, row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.nombre_postulante.trim()) return alert('El nombre del postulante es obligatorio.');
    if (!form.primera_induccion_fecha) return alert('Indique la fecha de la primera inducción.');
    if (!form.segunda_induccion_fecha) return alert('Indique la fecha de la segunda inducción.');
    const primera_induccion_hora = hora12a24(form.primera_h_12, form.primera_min, form.primera_ap);
    const segunda_induccion_hora = hora12a24(form.segunda_h_12, form.segunda_min, form.segunda_ap);
    const payload = {
      nombre_postulante: form.nombre_postulante,
      estado: form.estado,
      primera_induccion_fecha: form.primera_induccion_fecha,
      primera_induccion_hora,
      segunda_induccion_fecha: form.segunda_induccion_fecha,
      segunda_induccion_hora,
    };
    try {
      await onSave(payload);
      onClose(true);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || 'Error al guardar.');
    }
  };

  const TimeBlock = ({ label, prefix, required }) => (
    <FormGroup>
      <Label>
        {label}
        {required ? <span style={{ color: 'red' }}> *</span> : null}
      </Label>
      <div className="induccion-time-group">
        <Input
          type="select"
          name={`${prefix}_h_12`}
          className="form-control induccion-time-h"
          value={form[`${prefix}_h_12`]}
          onChange={handleChange}
        >
          {HORAS_12.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </Input>
        <span className="induccion-time-sep" aria-hidden="true">
          :
        </span>
        <Input
          type="select"
          name={`${prefix}_min`}
          className="form-control induccion-time-m"
          value={form[`${prefix}_min`]}
          onChange={handleChange}
        >
          {MINUTOS.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </Input>
        <Input
          type="select"
          name={`${prefix}_ap`}
          className="form-control induccion-time-ap"
          value={form[`${prefix}_ap`]}
          onChange={handleChange}
        >
          <option value="AM">a. m.</option>
          <option value="PM">p. m.</option>
        </Input>
      </div>
    </FormGroup>
  );

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal modal-induccion-crear" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{row ? 'EDITAR INDUCCIÓN' : 'NUEVA INDUCCIÓN'}</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form className="fila" onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>
                Postulante: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                className="form-control"
                type="text"
                name="nombre_postulante"
                value={form.nombre_postulante}
                onChange={handleChange}
                placeholder="Nombre completo"
                maxLength={255}
              />
            </FormGroup>

            <FormGroup>
              <Label>Estado:</Label>
              <Input className="form-control" type="select" name="estado" value={form.estado} onChange={handleChange}>
                <option value="1">Pendiente</option>
                <option value="2">En proceso</option>
                <option value="3">Finalizado</option>
                <option value="4">Abandono de Inducción</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label>
                Primera inducción — fecha: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                className="form-control"
                type="date"
                name="primera_induccion_fecha"
                value={form.primera_induccion_fecha}
                onChange={handleChange}
              />
            </FormGroup>

            <TimeBlock label="Primera inducción — hora:" prefix="primera" required />

            <FormGroup>
              <Label>
                Segunda inducción — fecha: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                className="form-control"
                type="date"
                name="segunda_induccion_fecha"
                value={form.segunda_induccion_fecha}
                onChange={handleChange}
              />
            </FormGroup>

            <TimeBlock label="Segunda inducción — hora:" prefix="segunda" required />

            <FormGroup>
              <div className="button-container">
                <Button className="button-custom" onClick={handleSubmit}>
                  {row ? 'ACTUALIZAR' : 'REGISTRAR'}
                </Button>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalInduccionCrear;
